import React from 'react'

const ActiveIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26"
		height="26"
		fill="none"
		viewBox="0 0 26 26"
		className="absolute -top-3"
	>
		<rect width="26" height="26" fill="#FFF7E3" rx="13" />
		<path
			fill="#FFB600"
			d="M10.893 14.93l-1.867-1.866L8 14.09l2.463 2.463.003-.003.45.45 6.953-6.954L16.823 9l-5.93 5.93z"
		/>
	</svg>
)

export default ActiveIcon
